import APIController from "./APIController"
import {useWebSocket} from "../Context/WebSocketContext";

const Order = () => {
    //Requesthelper
    const { basicRequest, jsonRequest, getWorkspaceId } = APIController()
    const {isOnline} = useWebSocket()

    const createOrder = async (orderDTO) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/order/new`, "POST", orderDTO);
        return data;
    };

    const updateOrder = async (orderDTO, id) =>{
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/order/update/${id}`, "PUT", orderDTO);
        return data;
    }

    const caluclatePrice = async (orderDTO) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/order/calculate`, "POST", orderDTO);
        return data;
    };

    const openOrderToday = async () => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/order`);
        return data;
    };

    const getAllOrders = async () => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        if (isOnline === false) return 
        const data = await jsonRequest(`/${workspaceId}/order/all`);
        return data;
    };

    const getStatistics = async (startDate, endDate) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId || !isOnline) return null;
        const startISO = new Date(startDate).toISOString();
        const endISO = new Date(endDate).toISOString();
        const data = await jsonRequest(`/${workspaceId}/order/statistic?startTime=${startISO}&endTime=${endISO}`);
        return data;
    };

    const closedOrderToday = async () => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/order/closed`);
        return data;
    };

    const openPreorderToday = async () => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/order/closed`);
        return data;
    };

    const checkoutOrder = async (id) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/order/checkout/${id}`, "PUT");
        return data;
    };

    const cancelOrder = async (id) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/order/cancel/${id}`, "DELETE");
        return data;
    };

    const createPayment = async (paymentDTO) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/order/create-payment`, "POST", paymentDTO);
        return data;
    }

    const startPayment = async (terminalId, aymount) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/order/start-payment/${terminalId}/${aymount}`, "POST");
        return data;
    }

    const validatePayment = async (terminalId, status) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/order/validate-payment/${terminalId}/${status}`, "POST");
        return data;
    }

    const getReciept = async (workspaceId, offlineId) => {
        if (!workspaceId) return null;
        const data = await jsonRequest(`/reciept/${workspaceId}/${offlineId}`, "GET");
        return data;
    }

    return {
        createOrder,
        caluclatePrice,
        openOrderToday,
        closedOrderToday,
        openPreorderToday,
        checkoutOrder,
        cancelOrder,
        getStatistics,
        createPayment,
        startPayment,
        validatePayment,
        updateOrder,
        getAllOrders,
        getReciept
    }
}

export default Order